import { omit } from 'lodash'

const stripUndefined = val => {
  if (Array.isArray(val)) return val.map(stripUndefined).filter(v => v !== undefined)
  if (val && typeof val === 'object') {
    return Object.fromEntries(
      Object.entries(val)
        .map(([k, v]) => [k, stripUndefined(v)])
        .filter(([, v]) => v !== undefined)
    )
  }
  return val === undefined ? undefined : val
}

export const receptionConverter = {
  toFirestore(data) {
    return stripUndefined(omit(data, ['id']))
  },

  fromFirestore(doc, options) {
    const data = doc.data(options) || {}

    const toDate = timestamp => {
      if (!timestamp) return null
      if (timestamp.toDate) return timestamp.toDate()
      if (timestamp.seconds) return new Date(timestamp.seconds * 1000)
      return timestamp
    }

    return {
      ...data,
      id: doc.id,
      // Normalize timestamps using toDate helper for better compatibility
      createdAt: toDate(data?.createdAt),
      updatedAt: toDate(data?.updatedAt),
      receptionDate: toDate(data?.receptionDate),
      purchaseInvoiceCreatedAt: toDate(data?.purchaseInvoiceCreatedAt),
      // New model
      type: typeof data.type === 'string' ? data.type : null,
      // Only add expertService if it actually exists in the document
      // Don't add it to non-expert receptions
      ...(data.expertService ? { expertService: data.expertService } : {}),
      // Legacy fields (read-only)
      expertServices: Array.isArray(data.expertServices) ? data.expertServices : [],
      images: Array.isArray(data.images) ? data.images : [],
      featuredImage: data?.featuredImage ?? null,
      analysis: {
        ...data?.analysis,
        purposes: Array.isArray(data?.analysis?.purposes) ? data.analysis.purposes : [],
      },
      purposeOfSale: Array.isArray(data.purposeOfSale) ? data.purposeOfSale : [],
      experts: Array.isArray(data.experts) ? data.experts : [],
      allExperts: Array.isArray(data.allExperts) ? data.allExperts : [],
    }
  },
}
